import React, { useEffect, useState } from "react";
import {   
  Dialog,
  DialogSurface,
  DialogBody,
  DialogContent
 } from "@fluentui/react-components";
import AddNotes from "./Addnotes";
import AddNote from "./AddNote";
import useToast from "../../hooks/useToast";
import services from "../../services/indexService";

const AddNotesPopup = ({open, handleClose, policyData}) => {
    const { Toaster, notify } = useToast();
  const [isAddNote, setIsAddNote] = useState(false);
  const [notesList, setNotesList] = useState([]);
  
    const handleAddNote = () => {
    setIsAddNote((prev) => !prev);
  };

  useEffect(() => {
    getNotesDetails();
  }, []);

  const getNotesDetails = async () => {
    try {
      notify("progress");
      const result = await services.getNotes(policyData?.policyID, '/Notepad/GetNotepadsForPolicyPermanent'); // 6761744
      notify("success", "Notes data fetch successful!");
      setNotesList(result);
    //   setTaskPaneState((prev) => ({ ...prev, userId: result[0].userID }));
    } catch (e) {
      notify("error", "Failed to fetch Notes data");
      console.log(e);
    }
  };

  const handleSubmitAddNotes = () => {
    handleAddNote();
    getNotesDetails();
  }
    return (
    <Dialog open={open} aria-label="Policy notes" onOpenChange={(_, data) => { if (!data.open) handleClose?.(); }}>
        {Toaster}
            <DialogSurface>
              <DialogBody>
                {/* <DialogTitle>Add Policy Notes</DialogTitle> */}
                <DialogContent>
                  {isAddNote ? (
                    <AddNote handleCloseAddNotes ={handleAddNote} handleSubmitAddNotes={handleSubmitAddNotes} />
                  ) : (
                    <AddNotes notesList={notesList} handleClose ={handleClose} handleAddNote={handleAddNote} />
                  )}
                </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
    )
}

export default AddNotesPopup;